// pages/mumbai-zing.js
import React from "react";
import ChatbotDemo from "../../components/ChatbotDemo";

const CLIENT_N8N_WEBHOOK_URL = "http://localhost:5678/webhook/19180aab-fe09-417c-97d7-c6445971b3e2/chat";
const CLIENT_NAME = "Mumbai Zing";

const CLIENT_BRANDING = {
  logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  name: {CLIENT_NAME},
  description: "Spice up your automation 🌶️",
};

const CLIENT_INITIAL_MESSAGES = [
    `Namaste, I'm Zing! 👋🏽`,
    `Ask me anything about ${CLIENT_NAME} - I'm here to help.`,
];

const CLIENT_I18N = {
  en: {
    title: "Welcome to Mumbai Zing! 🌶️",
    subtitle: "Home of unforgetable memories and flavours from the streets of Mumbai!",
    footer: "",
    getStarted: "Start Chat",
    inputPlaceholder: "Type here...",
  },
};

const MumbaiZingDemo = () => (
  <ChatbotDemo
    webhookUrl={CLIENT_N8N_WEBHOOK_URL}
    branding={CLIENT_BRANDING}
    initialMessages={CLIENT_INITIAL_MESSAGES}
    i18n={CLIENT_I18N}
    clientName={CLIENT_NAME}
    headline=""
    subtext="Smarter Service, Spicier Results. Support customer enquiries, streamline bookings, and grow your restaurant with your own AI assistant."
  />
);

export default MumbaiZingDemo;
